import { Typography } from "@mui/material";
import styles from "./ConfirmationTable.module.css";
import React from "react";

type Data = {
	label: string;
	value: string;
};

type ConfirmationTableProps = {
	data: Data[];
};

export default function ConfirmationTable({ data }: ConfirmationTableProps) {
	return (
		<div className={styles.infoTable}>
			{data.map((datum, idx) => (
				<React.Fragment key={idx}>
					<Typography className={styles.fieldName}>{datum.label}</Typography>
					<Typography className={styles.fieldValue}>{datum.value}</Typography>
				</React.Fragment>
			))}
		</div>
	);
}
